const PageTitle = "Paula Bramwell, Clinical Psychologist : enlighten - empower - evolve";

export default PageTitle;